'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = require('./components/Alert.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/alert/index.js
// module id = 175
// module chunks = 1